import { Box, FormControl, InputLabel, Select, MenuItem } from '@mui/material';

export interface FilterOption {
  value: string;
  label: string;
}

export interface SortOption {
  value: string;
  label: string;
}

export interface RequestListControlsConfig {
  filterEnabled?: boolean;
  sortEnabled?: boolean;
  filterOptions?: FilterOption[];
  sortOptions?: SortOption[];
  currentFilter?: string;
  currentSort?: string;
  onFilterChange?: (filter: string) => void;
  onSortChange?: (sort: string) => void;
  filterLabel?: string;
  sortLabel?: string;
  // Label for the unfiltered option (value '')
  allLabel?: string;
}

interface RequestListControlsProps {
  filterOptions?: FilterOption[];
  sortOptions?: SortOption[];
  currentFilter?: string;
  currentSort?: string;
  onFilterChange?: (filter: string) => void;
  onSortChange?: (sort: string) => void;
  filterLabel?: string;
  sortLabel?: string;
  // Label for the unfiltered option (value '')
  allLabel?: string;
}

export const RequestListControls = ({
  filterOptions,
  sortOptions,
  currentFilter,
  currentSort,
  onFilterChange,
  onSortChange,
  filterLabel = 'Filter',
  sortLabel = 'Sort by',
  allLabel = 'All',
}: RequestListControlsProps) => {
  const showFilter = filterOptions && filterOptions.length > 0 && onFilterChange;
  const showSort = sortOptions && sortOptions.length > 0 && onSortChange;

  if (!showFilter && !showSort) {
    return null;
  }

  return (
    <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
      {showFilter && (
        <FormControl size="small" sx={{ minWidth: 120 }}>
          {/* shrink + displayEmpty so the unfiltered option ('') shows its label */}
          <InputLabel shrink>{filterLabel}</InputLabel>
          <Select
            value={currentFilter || ''}
            label={filterLabel}
            displayEmpty
            notched
            onChange={(e) => onFilterChange(e.target.value)}
          >
            <MenuItem value="">{allLabel}</MenuItem>
            {filterOptions.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}

      {showSort && (
        <FormControl size="small" sx={{ minWidth: 120 }}>
          <InputLabel>{sortLabel}</InputLabel>
          <Select
            value={currentSort || ''}
            label={sortLabel}
            onChange={(e) => onSortChange(e.target.value)}
          >
            {sortOptions.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}
    </Box>
  );
};
